import Vue from 'vue'
import VueRouter from 'vue-router'
import Pc from '../layout/pc.vue'
import Mobile from '../layout/mobile.vue'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
let isMobile=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
console.log(isMobile)
const routes = [
  {
    path: '/',
    name: 'home',
    redirect: (isMobile?'/mobile/home':'/pc/home'),
    component: Pc
  },
  {
    path: '/pc',
    component: Pc,
    redirect: '/pc/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/pc/home'),
        meta: { title: '首页', noCache: true }
      },
			{
			  path: 'about',
			  component: () => import('@/views/pc/about'),
			  meta: { title: '关于我们', noCache: true }
			},
			{
			  path: 'business',
			  component: () => import('@/views/pc/business'),
			  meta: { title: '业务布局', noCache: true }
			},
			{
			  path: 'cinema',
			  component: () => import('@/views/pc/cinema'),
			  meta: { title: '橙猩VR影院', noCache: true }
			},
			{
			  path: 'team',
			  component: () => import('@/views/pc/team'),
			  meta: { title: '', noCache: true }
			},
			{
			  path: 'see',
			  component: () => import('@/views/pc/see'),
			  meta: { title: '橙猩视点', noCache: true }
			},
			{
			  path: 'seeInfo',
			  component: () => import('@/views/pc/seeInfo'),
			  meta: { title: '橙猩视点详情', noCache: true }
			},
			{
			  path: 'seeOut',
			  component: () => import('@/views/pc/seeOut'),
			  meta: { title: '橙猩视点详情', noCache: true }
			},
			{
			  path: 'contect',
			  component: () => import('@/views/pc/contect'),
			  meta: { title: '联系我们', noCache: true }
			},
    ]
  },
  {
    path: '/mobile',
    component: Mobile,
    redirect: '/mobile/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/mobile/home'),
        meta: { title: '首页', icon: 'guide', noCache: true }
      },
			{
			  path: 'about',
			  component: () => import('@/views/mobile/about'),
			  meta: { title: '关于我们', noCache: true }
			},
			{
			  path: 'business',
			  component: () => import('@/views/mobile/business'),
			  meta: { title: '业务布局', noCache: true }
			},
			{
			  path: 'cinema',
			  component: () => import('@/views/mobile/cinema'),
			  meta: { title: '橙猩VR影院', noCache: true }
			},
			{
			  path: 'team',
			  component: () => import('@/views/mobile/team'),
			  meta: { title: '', noCache: true }
			},
			{
			  path: 'see',
			  component: () => import('@/views/mobile/see'),
			  meta: { title: '橙猩视点', noCache: true }
			},
			{
			  path: 'seeInfo',
			  component: () => import('@/views/mobile/seeInfo'),
			  meta: { title: '橙猩视点详情', noCache: true }
			},
			{
			  path: 'contect',
			  component: () => import('@/views/mobile/contect'),
			  meta: { title: '联系我们', noCache: true }
			},
    ]
  },  
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
	scrollBehavior (to, from, savedPosition) {
	// 滚动条滚动到哪个的位置
	return { x: 0, y: 0 }
	}
})
router.beforeEach((to,from,next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = '橙猩数娱-'+to.meta.title;
  }
  next()
});
export default router
